export default __webpack_public_path__ + "static/media/18.3f6447e2.png";